// extracted by mini-css-extract-plugin
module.exports = {"messageContainer":"BillModuleMessage_messageContainer__v4wCC"};